var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FaqClientMultiple"},[(!_vm.$store.state.user.isSP)?_c('FaqClientPage',{ref:"faqClient"}):_vm._e(),_vm._v(" "),(_vm.$store.state.user.isSP)?_c('FaqClientWindow',{ref:"faqClient"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }